import ModalFilterDetails from 'Components/ModalFilterDetails'
import { notifyParent } from 'mailup-react-helpers'
import {
  modalFilterDetailsState,
  modalWelcomeReactivationState
} from 'Pages/Workflow/recoil/state/modals'

import { useRecoilValue, useResetRecoilState } from 'recoil'

import ModalWelcomeReactivation from './Modals/ModalWelcomeReactivation'
import BoxEmailStatistics from './Step5/BoxEmailStatistics'
import BoxOptionalSettings from './Step5/BoxOptionalSettings'
import BoxSetup from './Step5/BoxSetup'
import BoxSmsStatistics from './Step5/BoxSmsStatistics'
import BoxWorkflow from './Step5/BoxWorkflow'
import Footer from './Step5/Footer'

const WorkflowWizardFifthStep = () => {
  //
  const { show: showWelcomeReactivation } = useRecoilValue(
    modalWelcomeReactivationState
  )

  //

  const reactivationClose = useResetRecoilState(modalWelcomeReactivationState)
  const reactivationConfirm = () => {
    reactivationClose()

    notifyParent('redirectMainFrame', [
      'databasebuilding_app_redirector.aspx?r=/databasebuilding/subscriptions/welcome/list'
    ])
  }

  //
  const {
    id: filterId,
    type: filterType,
    ...modalFilterDetails
  } = useRecoilValue(modalFilterDetailsState)
  const modalFilterDetailsClose = useResetRecoilState(modalFilterDetailsState)

  const handleModalFilterDetailsClose = () => {
    const editUrl = `filters_app_redirector.aspx?r=${encodeURIComponent(`/filters/form/${filterId}`)}`
    modalFilterDetailsClose()

    notifyParent('redirectMainFrame', [editUrl])
  }

  return (
    <>
      <ModalWelcomeReactivation
        show={showWelcomeReactivation}
        onCancel={reactivationClose}
        onConfirm={reactivationConfirm}
      />
      <ModalFilterDetails
        {...modalFilterDetails}
        id={filterId}
        type={filterType}
        onClose={modalFilterDetailsClose}
        onEdit={handleModalFilterDetailsClose}
      />
      <BoxSetup />
      <BoxWorkflow />
      <BoxEmailStatistics />
      <BoxSmsStatistics />
      <BoxOptionalSettings />
      <Footer />
    </>
  )
}

export default WorkflowWizardFifthStep
